import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { ContextPanelEl } from "common/widgets/context-panel";
import { ButtonEl } from "common/components/button";
import { ConfirmEl } from "common/components/confirm";
import { CreateEntityModalEl } from "common/widgets/create-entity-modal";
import { ButtonTheme } from "common/components/button/constants";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { THEME } from "common/components/confirm/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/panel";
import { RowLabelType } from "common/query-builder/query-entry-section/types";
import { Directions, PositioningStrategy } from "common/components/drop-menu/types";
import { CustomPropertyResourceType } from "common/report/stores/custom-properties";
import { BannerEl } from "common/components/banner";
import { BannerTheme, BannerType } from "common/components/banner/types";
import { MarkdownEl } from "common/components/markdown";
import { IncludeCustomPropertyType } from "common/query-builder/query-block/properties-menu/types";
import { EditorEl } from "./editor";
import { CustomPropertyHelpTextEl } from "./help-text";
const FieldErrorTooltip = (_ref) => {
  let {
    errors,
    field
  } = _ref;
  if (errors[field]) {
    return /* @__PURE__ */ jsx("div", { sel: ".custom-property-error-tooltip" }, /* @__PURE__ */ jsx(MarkdownEl, { sel: ".mp-tooltip-text", attrs: {
      text: errors[field]
    } }));
  }
  return null;
};
function renderUpsellButton(_ref2) {
  let {
    component,
    text,
    theme
  } = _ref2;
  return /* @__PURE__ */ jsx("div", { sel: ".upsell-button", "data-sentry-component": "renderUpsellButton", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top,
    size: DisplaySize.Medium
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, component.t("custom-property.upgrade-description")), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme,
    icon: "share"
  }, on: {
    click: component.openPricingUpsell
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, text));
}
export function template() {
  const {
    autocompleteOpen,
    autocompletePopup,
    currentAutocompleteLine,
    customProperty,
    errors,
    toCreate,
    toDelete,
    tooltipData
  } = this.state;
  const bannerText = this.getBannerText();
  return /* @__PURE__ */ jsx("div", { sel: ".custom-property-modal-wrapper", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !toCreate ? /* @__PURE__ */ jsx(ModalEl, { sel: ".custom-property-modal", attrs: {
    open: this.params.open,
    "grow-to-content": true,
    elref: "customPropertyModal"
  }, on: {
    change: this.modalStateChange
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.getHeaderText())), /* @__PURE__ */ jsx("form", { sel: ".custom-property-body", class: {
    "for-behaviors": this.isBehavioralProperty()
  } }, bannerText && /* @__PURE__ */ jsx("div", { sel: ".custom-property-section" }, /* @__PURE__ */ jsx(BannerEl, { attrs: {
    theme: BannerTheme.Info,
    "body-text": bannerText,
    type: BannerType.Embedded
  } })), /* @__PURE__ */ jsx("div", { sel: ".custom-property-section" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label" }, this.t("custom-property.name-title")), /* @__PURE__ */ jsx(FieldErrorTooltip, { errors, field: "name" })), /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-container" }, /* @__PURE__ */ jsx("input", { sel: ".custom-property-section-input", on: {
    input: (ev) => this.updateName(ev.target.value)
  }, attrs: {
    autocomplete: "off",
    elref: "nameInput"
  }, props: {
    size: 50,
    type: "text",
    value: this.getName()
  }, class: {
    "custom-property-error": !!errors.name
  } }))), this.isPersisted() ? /* @__PURE__ */ jsx("div", { sel: ".custom-property-section" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label" }, this.t("custom-property.description-title"), /* @__PURE__ */ jsx("div", { sel: ".custom-property-description-tooltip" }, this.t("custom-property.description-optional")))), /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-container" }, /* @__PURE__ */ jsx("input", { sel: ".custom-property-section-input", on: {
    input: this.updateDescription
  }, props: {
    size: 50,
    type: "text",
    value: this.getDescription()
  } }))) : null, /* @__PURE__ */ jsx("div", { sel: ".custom-property-builder" }, this.isBehavioralProperty() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label" }, this.t("custom-property.condition-title"))), /* @__PURE__ */ jsx("div", { sel: ".custom-property-query-events-section" }, /* @__PURE__ */ jsx(QueryEntrySectionEl, { entries: this.getQueryEntries(), enableWorkspaceFilterRestrictions: this.params.enableWorkspaceFilterRestrictions, hideEditControls: true, includeCustomProperties: IncludeCustomPropertyType.PersistedOnly, disableDeleteEntry: true, projectId: this.params.projectId, rowLabelType: RowLabelType.None, metricsMode: true, rowLimit: 1, rowTypes: this.getBehavioralSelectorTypes(), eventAggregatorFunctions: this.getBehavioralAggregationMethods(), propertyAggregatorFunctions: this.getBehavioralAggregationMethods(), trackName: this.params.trackName, userId: this.params.userId, workspaceId: this.params.workspaceId, onUpdate: this.handleQueryEventsSectionUpdate }))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".custom-property-flex-wrapper.custom-property-formula-flex-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label.custom-property-formula-label" }, this.t("custom-property.formula-title")), /* @__PURE__ */ jsx("div", { sel: ".custom-property-tooltip", on: {
    click: this.tooltipClicked
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "max-width": "480px",
    placement: Placement.Right,
    clickable: "true"
  } }, this.t("custom-property.formula-tooltip"))), /* @__PURE__ */ jsx(FieldErrorTooltip, { errors, field: "displayFormula" })), /* @__PURE__ */ jsx(SelectEl, { sel: ".custom-property-example-menu", attrs: {
    elref: "insertExample",
    "menu-width": 160,
    sections: this.getExampleSections(),
    "selected-option": this.t("custom-property.insert-example"),
    "disable-search": true
  }, on: {
    change: this.handleInsertExample
  } })), /* @__PURE__ */ jsx("div", { sel: ".custom-property-input-area", class: {
    "custom-property-error": !!errors.displayFormula
  } }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-ace-wrapper", key: "ace-editor" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-border" }), this.isEditorReady() && /* @__PURE__ */ jsx(EditorEl, { attrs: {
    "all-data-groups": this.params.allDataGroups,
    "composed-properties": JSON.stringify(customProperty.composedProperties),
    "data-group-id": this.params.dataGroupId,
    "display-formula": customProperty.displayFormula,
    "event-names": this.params.eventNames,
    "enable-workspace-filter-restrictions": this.params.enableWorkspaceFilterRestrictions,
    "show-borrowed-properties": this.params.showBorrowedProperties,
    "project-id": this.params.projectId,
    "resource-type": this.getResourceType(),
    "user-id": this.params.userId,
    "workspace-id": this.params.workspaceId,
    "show-borrow-property-action": this.canUseBorrowedProperties() && this.getResourceType() === CustomPropertyResourceType.Events,
    elref: "ace-editor"
  }, on: {
    connect: this.handleEditorConnect,
    change: this.handleValueChange,
    autocompleteChange: this.handleEditorAutocompleteChange
  }, hook: {
    insert: this.handleEditorElementInsert
  } }), /* @__PURE__ */ jsx("div", { sel: ".custom-property-border" })), autocompletePopup ? /* @__PURE__ */ jsx(ContextPanelEl, { attrs: {
    placement: autocompleteOpen ? Directions.Right : Directions.Left,
    "force-placement": !autocompleteOpen,
    "always-expanded": true,
    "position-strategy": PositioningStrategy.Fixed
  }, params: {
    data: tooltipData,
    positionParent: autocompleteOpen ? autocompletePopup : currentAutocompleteLine
  } }) : null), /* @__PURE__ */ jsx("div", { sel: ".custom-property-info-tooltip" }, /* @__PURE__ */ jsx(CustomPropertyHelpTextEl, null))))), /* @__PURE__ */ jsx("div", { sel: ".custom-property-footer" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-flex-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-action-wrapper" }, (() => {
    if (this.isPersisted()) {
      return /* @__PURE__ */ jsx(ButtonEl, { on: {
        click: this.setToDelete
      } }, this.t("common.delete"));
    } else if (!this.isBehavioralProperty() && !this.usesBorrowedProperty()) {
      if (this.isSavingRestricted()) {
        return renderUpsellButton({
          component: this,
          text: this.t("custom-property.upgrade-cta"),
          theme: ButtonTheme.Secondary
        });
      } else if (!this.params.enableWorkspaceFilterRestrictions) {
        return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
          disabled: this.isSavingDisabled()
        }, on: {
          click: () => this.applyProperty(true)
        } }, this.t("common.save"));
      }
      return null;
    }
    return null;
  })())), /* @__PURE__ */ jsx(ButtonEl, { sel: ".custom-property-button.custom-property-cancel-button", attrs: {
    theme: ButtonTheme.Tertiary
  }, on: {
    click: this.closeModal
  } }, this.t("common.cancel")), this.isEdit() && this.isPersisted() ? this.isSavingRestricted() ? renderUpsellButton({
    component: this,
    text: this.t("custom-property.upgrade-cta-update"),
    theme: ButtonTheme.Primary
  }) : /* @__PURE__ */ jsx(ButtonEl, { sel: ".custom-property-button.custom-property-save-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: this.isSavingDisabled()
  }, on: {
    click: () => this.applyProperty(false)
  } }, this.t("common.save")) : this.usesBorrowedProperty() && this.isSavingRestricted() ? renderUpsellButton({
    component: this,
    text: this.t("custom-property.upgrade-cta"),
    theme: ButtonTheme.Primary
  }) : /* @__PURE__ */ jsx(ButtonEl, { sel: ".custom-property-button.custom-property-save-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: this.isSavingDisabled(),
    elref: "applyButton"
  }, on: {
    click: () => this.applyProperty(this.usesBorrowedProperty())
  } }, this.usesBorrowedProperty() ? this.t("common.save") : this.t("common.apply"))), /* @__PURE__ */ jsx(ConfirmEl, { attrs: {
    theme: THEME.DELETE,
    open: !!toDelete,
    closeable: true
  }, on: {
    change: (ev) => this.handleDeleteConfirmChange(ev.detail.state),
    submit: (ev) => {
      if (ev.detail.action === "confirm") {
        this.deleteProperty();
      }
    }
  } }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-title" }, this.t("custom-property.header.delete")), /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description" }, this.t("custom-property.delete-confirmation", {
    customPropertyName: customProperty.name
  }))))) : /* @__PURE__ */ jsx(CreateEntityModalEl, { attrs: this.buildCreateEntityModalAttrs(), on: {
    nameInput: (ev) => this.updateName(ev.detail.name),
    save: this.handleCreate,
    cancel: this.handleCancelCreate,
    saveAndShare: this.handleCreate
  }, props: {
    existingEntityNames: this.getPersistedCustomPropertyNames()
  } }));
}
